module.exports = __webpack_public_path__ + "img/027-what are you doing.8b223659.svg";